/* eslint-disable */
import * as Types from '../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type DeleteAocVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteAocDTO = (
  { __typename?: 'Mutation' }
  & { updateOneAoc: (
    { __typename?: 'Aoc' }
    & Pick<Types.AocDTO, 'id'>
  ) }
);


export const DeleteAocDocumentDTO = gql`
    mutation deleteAoc($id: String!) {
  updateOneAoc(id: $id, data: {archived: true}) {
    id
  }
}
    `;
export type DeleteAocMutationFnDTO = Apollo.MutationFunction<DeleteAocDTO, DeleteAocVariablesDTO>;

/**
 * __useDeleteAoc__
 *
 * To run a mutation, you first call `useDeleteAoc` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAoc` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAoc, { data, loading, error }] = useDeleteAoc({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAoc(baseOptions?: Apollo.MutationHookOptions<DeleteAocDTO, DeleteAocVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAocDTO, DeleteAocVariablesDTO>(DeleteAocDocumentDTO, options);
      }
export type DeleteAocHookResult = ReturnType<typeof useDeleteAoc>;
export type DeleteAocMutationResultDTO = Apollo.MutationResult<DeleteAocDTO>;
export type DeleteAocMutationOptionsDTO = Apollo.BaseMutationOptions<DeleteAocDTO, DeleteAocVariablesDTO>;